define('views/components/store_product/store_category',['require','backbone','views/components/store_product/store_product','marionette','metro','dialogFx','imagesLoaded','jquery-bridget','isotope','text!templates/components/store_product/store_category.html','collections/products'],function (require) {

    var Backbone = require('backbone');
    var ChildView = require('views/components/store_product/store_product');

    require('marionette');
    require("metro");
    require("dialogFx");
    require("imagesLoaded");
    require("jquery-bridget");
    require("isotope");


    var temp = require("text!templates/components/store_product/store_category.html");

    var ProductsCollection = require('collections/products');

    return Backbone.Marionette.CompositeView.extend({
        template: _.template(temp),
        tagName: 'div',
        className: "",
        childViewContainer: '.gallery',
        childView: ChildView,


        initialize: function (args) {
            this.setSelecetedProduct = args.setSelecetedProduct;
            this.form_cliked = false;
            
            this.collection = new ProductsCollection([], {
                parameters: {
                    'category__code': this.model.get('code'),
                    'limit': 100
                }
            });
            this.listenTo(this.collection, 'fetch_complete', this._onFetch);

            this.collection.fetch();

        },
        ui: function () {
            return {
                galleryItem: '.gallery-item',
                countForm: '.count_form'
            };
        },

        events: {
            'click @ui.galleryItem': 'showDetail',
            'click @ui.countForm': 'hideDetail',
        },

        _onFetch: function () {
            this.render();
        },
        onRender: function () {
            this.gallery();
        },

        gallery: function () {
            var _this = this;
            var category_id = "#"+ _this.model.get("id") +"_category";
            /* GRID
            -------------------------------------------------------------*/

            /* 
                Wait for the images to be loaded before applying
                Isotope plugin. 
            */
            //var $gallery = this.ui.deneme;

            $(category_id).imagesLoaded(function () {
                applyIsotope();
            });

            /*  Apply Isotope plugin 
                isotope.metafizzy.co
            */
            var applyIsotope = function () {
                $(category_id).isotope({
                    itemSelector: '.gallery-item',
                    isOriginLeft: true,
                    masonry: {
                        columnWidth: 220,
                        gutter: 10,
                    }
                });
            };

            /*
                Show a sliding item using MetroJS
                http://www.drewgreenwell.com/projects/metrojs
            */
            $(".live-tile,.flip-list").liveTile();
    

            /*
                Look for data-image attribute and apply those
                images as CSS background-image 
            */
            $('.item-slideshow > div').each(function () {
                var img = $(this).data('image');
                $(this).css({
                    'background-image': 'url(' + img + ')',
                    'background-size': 'cover'
                });
            });

            /* 
                Touch enabled slideshow for gallery item images using owlCarousel
                www.owlcarousel.owlgraphic.com
            
            $(".item-slideshow").owlCarousel({
                items: 1,
                nav: true,
                navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
                dots: true
            });
            
            */


            /* FILTERS OVERLAY
           -------------------------------------------------------------*/

            $('[data-toggle="filters"]').click(function () {
                $('#filters').toggleClass('open');
            });

        },
        showDetail: function (event) {

        /* DETAIL VIEW
       -------------------------------------------------------------*/

        /*
            Toggle detail view using DialogFx
            http://tympanus.net/Development/DialogEffects/
        */
            var _this = this;

            if (!_this.form_cliked) {
                var child = _this.collection.where({ name: event.currentTarget.id });
                var attributes = child[0].attributes;
                var image_name = attributes.image_name;
                var product_image = attributes.product_image;

                var visibility = false;
                var image_element = $("<div>").addClass("slide");
                image_element.attr("data-image", App.Config.productImagesUrl + product_image.image);
                _this.setSelecetedProduct(child[0].attributes);
                if (!((App.user && App.user.get('reseller')) || attributes.license_type == 2) || attributes.license_name == 'ResellerStarterPack') {
                    visibility = true;
                }
                var dlg = new DialogFx($('#itemDetails').get(0));
                if (visibility)
                    $(".form_count").addClass("invisible");
                else
                    $(".form_count").removeClass("invisible");
                $(".selectedProduct_name").text(attributes.name);
                $(".selectedProduct_info").html(attributes.info);
                $(".selectedProduct_price").text(attributes.effective_price);
                $(".curency").text(App.utils.getProductCurrencySign(attributes.exchange_currency));
                if (App.user) {
                    $(".selectedProduct_rsp").text("(RSP:" + (attributes.recommended_sales_price ?
                        attributes.recommended_sales_price.price
                        : 0));
                    $(".rsp_curency").text(App.utils.getProductCurrencySign(attributes.recommended_sales_price.exchange_currency) + ")");
                }
                $(".slide ").attr("style", "background-image: url(" + App.Config.productImagesUrl + product_image.image + "); background-size:cover;");
                dlg.toggle();
            }

            form_cliked = false;
        },
        hideDetail : function () {
        /* Click on count form and small add button, it will not open the detail modal */
            this.form_cliked = true;
        }

    });
});
